<template>
  <v-container fluid class="px-0 py-0">
    <drawer-left>
      <template v-slot:left>
        <div class="pr-3">
          <v-select @change="onDomainChange" label="领域" v-model="domain" :items="domains" item-text="name"
            item-value="id"></v-select>
          <v-select @change="onOrgChange" label="范围" v-model="org" :items="orgs" item-text="name" item-value="id">
          </v-select>
        </div>
      </template>
      <template v-slot:right>
        <crud v-if="crudCfg" :cfg="crudCfg" :timestamp="crudTimestamp" />
      </template>
    </drawer-left>
  </v-container>
</template>

<script>
import { Crud, DrawerLeft } from "javaee-fre";
export default {
  name: "article-repo",
  components: {
    crud: Crud,
    "drawer-left": DrawerLeft,
  },
  data() {
    return {
      crudCfg: null,
      crudTimestamp: Date.now(),
      domains: [],
      domain: null,
      orgs: [],
      org: null,
    };
  },
  methods: {
    init() {
      let self = this,
        axios = self.$axios;
      function getDomains() {
        return axios.get("/home/my/tenant/domain/list");
      }
      function getOrgs() {
        return axios.get("/home/my/tenant/org/parent");
      }

      axios.all([getDomains(), getOrgs()]).then(
        axios.spread((r1, r2) => {
          self.domains = r1.data.message;
          if (self.domains.length > 0) {
            self.domain = self.domains[0].id;
          }
          let orgs = [
            { name: "平台共享", id: "_" },
            { name: "企业共享", id: 0 },
          ];
          if (r2.data && r2.data.message) {
            orgs.push(...r2.data.message);
          }
          self.orgs = orgs;
          self.org = orgs[0].id;

          self.fillCrud({
            url: "/home/my/article",
            detailable: false,
            listItemActions: [
              {
                label: "收藏",
                icon: "favorite_border",
                func(cfg) {
                  this.$favorite(5, cfg.item.id);
                },
              },
              {
                label: "预览",
                icon: "visibility",
                func(cfg) {
                  let self = this;
                  self.$dialog.component("预览", "article-view", {
                    id: cfg.item.id
                  });
                },
              },
            ],
          });
        })
      );
    },
    onDomainChange() {
      this.fillCrud();
    },
    onOrgChange() {
      this.fillCrud();
    },
    fillCrud(cfg) {
      let self = this,
        noFirst = !cfg;
      if (noFirst) {
        cfg = self.crudCfg;
      }
      if (!cfg) {
        return;
      }
      let params = cfg.params || {};
      params._org = self.org == "_" ? null : self.org;
      params._domain = self.domain;
      cfg.params = params;
      if (noFirst) {
        self.crudTimestamp = Date.now();
      } else {
        self.crudCfg = cfg;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
